




























import Headers from '@/components/header/Headers.vue';
import Main from '@/components/main/Main.vue';
import PasswordUpdate from '@/components/header/PasswordUpdate.vue';
import CosPopup from '@/components/common/CosPopup.vue';
import Footers from '@/components/Footers.vue';
import {Vue, Component} from 'vue-property-decorator';
import { cosSectionCode } from '@/const/cosSection';
import {State} from 'vuex-class';

@Component({
  components: {Headers, Footers, mains: Main, PasswordUpdate, CosPopup},
  computed: {
    cosSectionCode() {
      return cosSectionCode;
    },
  },
})
export default class MainView extends Vue {
  @State private onGnb!: boolean;
  private gnbid: number = -1;
  private className: string = '';
  private mainMall = {
    no: 0
  };

  private pwdMustBeChanged = false;
  private isPwdShow = false;
  private isCloseModal = false;

  // created() {
  //   this.isCloseModal = Cookies.get('popup_period_premium') ? true : false;
  // }

  private async mounted() {
    const { data: { mustBeChanged, pastDays } } = await this.$api.getAdminsPasswordDate();
    const { data: { commerceAccount } } = await this.$api.getManagerInfo();
    this.pwdMustBeChanged = mustBeChanged;
    this.isPwdShow = !commerceAccount && mustBeChanged;

    // alert는 렌더링을 막으므로, 화면이 실제로 그려진 뒤에 띄운다
    this.$nextTick(() => requestAnimationFrame(() => setTimeout(this.handleContinueAction)));
  }

  private handleContinueAction() {
    const { continueAction, mallNo, ...rest } = this.$route.query;
    this.$router.replace({ query: rest }).catch(() => {});

    if (continueAction === 'redirectToSmsMigration') {
      alert('발신관리책임자 등록 또는 발신번호이관이 필요합니다.\n등록페이지로 이동합니다.');
      this.$router.push({ path: '/member/message/config', query: { mallNo } });
    } else if (continueAction === 'alertSmsMigration') {
      alert('발신관리책임자 등록 또는 발신번호이관이 필요합니다.\n대표운영자에게 요청해주세요.');
    }
  }

  // private closeAd(isSetCookie) {
  //   if (isSetCookie) {
  //     Cookies.set('popup_period_premium', 'ad', {expires: 3});
  //   }
  //
  //   this.isCloseModal = true;
  // }
}
